import fetchService from "../../../services/fetchService";
import { FETCH_ALL_IMAGES,  FETCH_IMAGE} from "../types";
import {FETCH_ALL_VIDEOS, FETCH_VIDEO } from "../videos/types";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchGalleryData = (page, limit)=> async (dispatch)=>
  await dispatch({
    type:FETCH_ALL_IMAGES,
    message: `Gallery Data`,
    payload: fetchService(`${baseUrl.backend}/api/gallery/photos?page=${page}&limit=${limit}`),
  })
  
export const fetchImageData = (id)=> async (dispatch) =>
  await dispatch({
    type: FETCH_IMAGE,
    message: `All Image Data`,
    payload: fetchService(`${baseUrl.backend}/api/gallery/photos/${id}`)
  })

export const fetchGalleryVideos = (page, limit) => async(dispatch) => 
  await dispatch({
    type:FETCH_ALL_VIDEOS,
    message:`gallery videos `,
    payload: fetchService(`${baseUrl.backend}/api/gallery/videos?page=${page}&limit=${limit}`),
  })

export const fetchVideoData = (id) => async (dispatch)=>{
  console.log(id,"these are the data");
  await dispatch({
    type:FETCH_VIDEO,
    message:`all video Data`,
    payload: fetchService(`${baseUrl.backend}/api/gallery/videos/${id}`),
  })
}
  